/**
 * Returns the cookieName value based on the environment
 */

import { settings } from "shared";

const apiCSRFCookieNames = {
  development: "api_dev_csrftoken",
  staging: "api_staging_csrftoken",
  test: "api_test_csrftoken",
  production: "api_csrftoken",
};
const userCookieNames = {
  development: "userid_local",
  staging: "userid_staging",
  test: "userid_test",
  production: "userid",
};

export const getCSRFCookieName = (): string => {
  const env = settings.environment;
  if (!env) throw new Error("Environment missing from config");

  return apiCSRFCookieNames[env] || apiCSRFCookieNames.production;
};

export const getUserCookieName = (): string => {
  const env = settings.environment;
  if (!env) throw new Error("Environment missing from config");

  return userCookieNames[env] || apiCSRFCookieNames.production;
};
